import type { AnalyticsProvider } from "../common/types";

export class NoopProvider implements AnalyticsProvider {
  track(): void {}
  identify(): void {}
  trackError(): void {}
}
